<template>
  <div>{{ currentRoute }}</div>
</template>

<script>
export default {
  name: "testStepView",
  components: {},
  computed: {
    currentRoute() {
      return this.$route.path;
    },
  },
};
</script>
